<template>
  <div class="home">
    <div class="ui bottom attached container" ref="modules_segment">
      <h2 class="ui center aligned icon header" id="modul_header"></h2>
      <div class="container">
        <div v-responsive.lg.xl>
          <desktop :display_modules="modules" @go_to_module="go_to_module" />
        </div>
        <div v-responsive.md>
          <tablet :display_modules="modules" @go_to_module="go_to_module" />
        </div>
        <div v-responsive.sm.xs>
          <smartphone :display_modules="modules" @go_to_module="go_to_module" />
        </div>
      </div>
      <!-- <h2 class="ui center aligned icon header" id="modul_header"></h2>
      <div class="container">
        <div class="ui six link cards">
          <div
            class="card"
            v-for="(module, index) in modules"
            v-bind:key="index"
            v-on:click="go_to_module(module)"
          >
            <div class="content">
              <h3 class="ui icon header" style="margin-bottom:0">
                <img :src="module.sys_module.setup.image" class="ui image" />
                <div class="content" style="margin-top:8px">
                  {{ $t(module.sys_module.setup.name) }}
                </div>
              </h3>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { local_api, clone, error_toast } from "@/utils";
import Desktop from "../../../views/home/Desktop.vue";
import Tablet from "../../../views/home/Tablet.vue";
import Smartphone from "../../../views/home/Smartphone.vue";
// @ is an alias to /src
export default {
  name: "Home",
  data() {
    return {
      modules: [],
    };
  },
  components: { Desktop, Tablet, Smartphone },
  methods: {
    go_to_module(suscription) {
      this.$router.push({
        name: suscription.sys_module.setup.index_route,
      });
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.modules_segment).addClass("loading");
    local_api(vm, "post", "/student_portal/user/do-get-home-modules")
      .then((response) => {
        let display_modules = response.sort(function(a, b) {
          if (a.sys_module.setup.name > b.sys_module.setup.name) return -1;
          if (a.sys_module.setup.name < b.sys_module.setup.name) return 1;
          return 0;
        });
        vm.modules = display_modules;
        vm.display_modules = clone(display_modules);
        window.jQuery(vm.$refs.modules_segment).removeClass("loading");
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  created() {
    if (this.$session.exists()) {
      let std_portal = this.$session.get("portal_user");
      this.$emit("switch_nav", { type: "student", data: std_portal });
    }
  },
  watch: {},
};
</script>

<style>
#modul_header {
  background-image: url(/images/backgrounds/Modul-15.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 75px;
}

.card .ui.header .content {
  font-size: 1.25rem !important;
}
</style>
